import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import {} from "react-router-dom";
import { withrawalRequest } from "../../actions/contestActions";
import { toast, Toaster } from "react-hot-toast";
import { Modal } from "react-bootstrap";
import * as myConstList from "../../BaseUrl";
import Loading from "../layout/Loading";
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const baseUrl = myConstList.baseUrl;
const publicStripeKey = myConstList.stripePublicKey;
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
};
class Withdral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      winningamount: 0,
      cashWalletBalance: 0,
      winningBalanceTab: false,
      depositBalanceTab: false,
      nextEnterAmount: false,
      walletBalanceTab: false,
      nextEnterKYC: true,
      totalDeposit: 0,
      totalUsedCash: 0,
      totalUsedWinning: 0,
      totalWinning: 0,
      depositTab: 1,
      winningTab: 0,
      upiTab: 1,
      bankTransferTab: 0,
      amount: "",
      upiId: "",
      accountHolderNumber: "",
      accountNumber: "",
      bankName: "",
      ifscCode: "",
      bankAddress: "",
      bankAttchment: "",
      attachment: "",
      totalAvailableWinning: 0,
      totalAvailableDeposit: 0,
      bankupiId: "",
      depositWithdrwal: 0,
      winningWithdrwal: 0,
      tdsDeduct: 0,
      reciveWithdrawalFromWinning: 0,
      totalRemainingWinning: 0,
      reciveWithdrawalFromDeposit: 0,
      totalRemainingDeposit: 0,
      depositDeductAmount: 0,
      deductFromWinningAmount: 0,
      documentVerify: false,
      confirmDetailTab: false,
      confirmPayment: false,
      themeSet: "",
      loadingProcess: false,
      bankData: "",
      upiData: "",
      kyc_verification: "",      
      urlKycUpload: "",
      mobileAttachment: "",
      existAttachment: "",
      disabledButton: false,
    };
    this.confrmAmountWinthdrwl = this.confrmAmountWinthdrwl.bind(this);
    this.getData = this.getData5.bind(this);
  }
  editRecord(record) {
    this.setState({ reject: record.reject, approve: record.approve });
  }
  componentWillReceiveProps(nextProps) {
    // console.log("nextPropsnextProps===========", nextProps);
    if (
      nextProps.contestdata !== undefined &&
      nextProps.contestdata.contest !== undefined &&
      nextProps.contestdata.contest.data !== undefined &&
      nextProps.contestdata.contest.data.message !== undefined &&
      nextProps.contestdata.contest.data.success
    ) {
      toast.success(nextProps.contestdata.contest.data.message, toastStyles);
      // this.getData5();
      var urltemp = "";
      if (
        localStorage.getItem("source") !== "" &&
        localStorage.getItem("theme") !== ""
      ) {
        urltemp =
          "?source=" +
          localStorage.getItem("source") +
          "&theme=" +
          localStorage.getItem("theme");
        // console.log("urlStamp==",urltemp);
        this.setState({
          urltemp: urltemp,
          themeSet: localStorage.getItem("theme"),
        });
      }
      setTimeout(() => {
        window.location.href = "/addCash" + urltemp;
      }, 1000);
    } else {
      this.getData5();
      if (
        nextProps.contestdata !== undefined &&
        nextProps.contestdata.contest !== undefined &&
        nextProps.contestdata.contest.data !== undefined &&
        nextProps.contestdata.contest.data.message !== undefined &&
        nextProps.contestdata.contest.data.success
      ) {
        toast.error(nextProps.contestdata.contest.data.message, toastStyles);
      }
    }
  }

  componentDidMount() {
    this.setState({ depositBalanceTab: true, walletBalanceTab: false });
    var urlTempParam = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      // console.log("urlStamp==",urltemp);
      this.setState({
        urltemp: urltemp,
        themeSet: localStorage.getItem("theme"),
      });
    }
    this.getData5();
  }
  getprofileData() {
    axios.post(baseUrl + "api/profile-data", {}, configToken).then((res) => {
      // console.log("profile-data=======",res.data.data);
      this.setState({
        cashWalletBalance: res.data.data.cashWalletBalance,
        winningCashAmount: res.data.data.winningCash,
        totalAvailableDeposit: res.data.data.cashWalletBalance,
        totalAvailableWinning: res.data.data.winningCash,
        kyc_verification: res.data.data.kyc_verification,
        // kyc_verification:'completed',
        totalBalanceWallet:
          Number(res.data.data.cashWalletBalance).toFixed(2) +
          Number(res.data.data.winningCash).toFixed(2),
      });
      if (res.data.data.kyc_verification == "completed") {
        this.setState({ walletBalanceTab: true, nextEnterKYC: false });
      }
    });
  }
  getData5() {
    const { user } = this.props.auth;
    axios
      .post(baseUrl + "api/profile-data", {}, configToken)
      .then((res) => {
        // console.log("profile-data=======",res.data.data);
        this.setState({
          cashWalletBalance: res.data.data.cashWalletBalance,
          winningCashAmount: res.data.data.winningCash,
          totalAvailableDeposit: res.data.data.cashWalletBalance,
          totalAvailableWinning: res.data.data.winningCash,
          kyc_verification: res.data.data.kyc_verification,
          kyc_verification:'completed',
          totalBalanceWallet:
            Number(res.data.data.cashWalletBalance).toFixed(2) +
            Number(res.data.data.winningCash).toFixed(2),
        });
        // if (res.data.data.kyc_verification == "completed") {
          this.setState({ walletBalanceTab: true, nextEnterKYC: false });
        // }
        // if (res.data.data.kyc_verification !== "completed") {
        //   this.setState({ loadingProcess: true });
        //   axios
        //     .post(
        //       baseUrl + "api/documentVerify",
        //       { userId: user.id },
        //       configToken
        //     )
        //     .then((res) => {
        //       this.getprofileData();
        //       this.setState({ loadingProcess: false });
        //       let kycVerify = 1;
        //       console.log("res.data.datares.data.data=", res.data.data);
        //       if (
        //         res &&
        //         res.data &&
        //         res.data.data &&
        //         res.data.data.eal.length == 2
        //       ) {
        //         if (
        //           res.data.data.eal[0].sta == 2 &&
        //           res.data.data.eal[1].sta == 2
        //         ) {
        //           kycVerify = 2;
        //         }
        //         if (
        //           res.data.data.eal[0].sta == 1 ||
        //           res.data.data.eal[1].sta == 1
        //         ) {
        //           kycVerify = 1;
        //         }
        //         if (
        //           res.data.data.eal[0].sta == 4 ||
        //           res.data.data.eal[1].sta == 4
        //         ) {
        //           kycVerify = 4;
        //         }
        //         if (
        //           res.data.data.eal[0].sta == 8 ||
        //           res.data.data.eal[1].sta == 8
        //         ) {
        //           kycVerify = 8;
        //         }
        //       }
        //       if (
        //         res &&
        //         res.data &&
        //         res.data.data &&
        //         res.data.data.eal.length == 1
        //       ) {
        //         if (res.data.data.eal[0].sta == 2) {
        //           kycVerify = 2;
        //         }
        //         if (res.data.data.eal[0].sta == 1) {
        //           kycVerify = 1;
        //         }
        //         if (res.data.data.eal[0].sta == 4) {
        //           kycVerify = 4;
        //         }
        //         if (res.data.data.eal[0].sta == 8) {
        //           kycVerify = 8;
        //         }
        //       }
        //       console.log("res.data.data==", kycVerify);
        //     })
        //     .catch();
        // }
      })
      .catch();
    axios
      .post(
        baseUrl + "api/check-account-detail-data",
        { userId: user.id },
        configToken
      )
      .then((res) => {
        if (res) {
          let upiData = "";
          let bankData = "";
          let i = 0;
          res.data.data.forEach((accountDetailData) => {
            console.log("accountDetailData===", accountDetailData);

            if (
              accountDetailData.upiId != null &&
              accountDetailData.upiId != ""
            ) {
              upiData = accountDetailData.upiId;
              const parts = upiData.split("@");
              this.setState({
                upiData: upiData,
                upiId: parts[0],
                bankupiId: "@" + parts[1],
              });
            }
            if (accountDetailData.accountHolderName != "") {
              bankData = accountDetailData.accountHolderName;
              this.setState({
                bankData: bankData,
                accountHolderNumber: accountDetailData.accountHolderName,
                accountNumber: accountDetailData.accountNumber,
                bankName: accountDetailData.bankName,
                ifscCode: accountDetailData.ifscCode,
                bankAddress: accountDetailData.bankAddress,
                existAttachment: accountDetailData.bankAttchment,
              });
            }
          });
        }
        // this.setState({ cashWalletBalance: res.data.data.cashWalletBalance, winningCashAmount: res.data.data.winningCash, totalAvailableDeposit: res.data.data.cashWalletBalance, totalAvailableWinning: res.data.data.winningCash,totalBalanceWallet:Number(res.data.data.cashWalletBalance).toFixed(2)+Number(res.data.data.winningCash).toFixed(2) })
      })
      .catch();
    axios
      .post(baseUrl + "api/total-amount", {}, configToken)
      .then((res) => {
        // console.log("res.data.data==================",res.data.data);
        let totalAvailableDeposit = 0;
        let totalAvailableWinning = 0;
        let totalUsedCash = 0;
        let totalUsedWinning = 0;
        let totalusedcashwallet = 0;
        let totalusedwinningwallet = 0;
        // console.log("res.data.data==",res.data.data);
        if (res.data.data && typeof res.data.data.totalDeposit != "undefined") {
          totalAvailableDeposit = res.data.data.totalDeposit;
        }
        if (res.data.data && typeof res.data.data.totalWinning != "undefined") {
          totalAvailableWinning = res.data.data.totalWinning;
        }
        if (
          res.data.data &&
          typeof res.data.data.totalUsedCash != "undefined"
        ) {
          totalUsedCash = res.data.data.totalUsedCash;
        }
        if (
          res.data.data &&
          typeof res.data.data.totalUsedWinning != "undefined"
        ) {
          totalUsedWinning = res.data.data.totalUsedWinning;
        }
        if (
          res.data.data &&
          typeof res.data.data.totalusedcashwallet != "undefined"
        ) {
          totalusedcashwallet = res.data.data.totalusedcashwallet;
        }
        if (
          res.data.data &&
          typeof res.data.data.totalusedwinningwallet != "undefined"
        ) {
          totalusedwinningwallet = res.data.data.totalusedwinningwallet;
        }

        this.setState({
          totalDeposit: totalAvailableDeposit,
          totalUsedCash: totalUsedCash,
          totalUsedWinning: totalUsedWinning,
          totalWinning: totalAvailableWinning,
          totalusedcashwallet: totalusedcashwallet,
          totalusedwinningwallet: totalusedwinningwallet,
        });
      })
      .catch();
    axios
      .post(baseUrl + "api/get-cashWallet-transactions", {}, configToken)
      .then((res) => {
        // console.log("CashWalletResponse=",res.data.data);
        this.setState({ cashWalletRecords: res.data.data });
      })
      .catch();
  }
  depositBalance = () => {
    this.setState({
      depositBalanceTab: true,
      winningBalanceTab: false,
      depositTab: 1,
      winningTab: 0,
    });
  };
  winningBalance = () => {
    this.setState({
      depositBalanceTab: false,
      winningBalanceTab: true,
      depositTab: 0,
      winningTab: 1,
    });
  };
  confirmDetailTabFun = () => {
    if (this.state.bankTransferTab == 1) {
      if (this.state.accountHolderNumber == "") {
        this.setState({
          erroraccountHolderNumber: "Please enter account holder name",
        });
        return false;
      }
      if (this.state.accountNumber == "") {
        this.setState({ erroraccountNumber: "Please enter account no" });
        return false;
      }
      if (this.state.accountNumber == this.state.confrmaccount) {
        this.setState({
          errorconfrmaccount: "Please enter valid confirm account number",
        });
        return false;
      }
      if (this.state.bankName == "") {
        this.setState({ errorbankName: "Please enter bank name" });
        return false;
      }
      if (this.state.ifscCode == "") {
        this.setState({ errorifscCode: "Please enter IFSC Code" });
        return false;
      }
      if (this.state.bankAddress == "") {
        this.setState({ errorbankAddress: "Please enter bank address" });
        return false;
      }

      // if (this.state.bankAttchment == "") {
      //   this.setState({ errorbankAttchment: "Please Attach" });
      //   return false;
      // }
    } else if (this.state.upiTab == 1) {
      if (this.state.upiId == "") {
        this.setState({ errorupiId: "Please enter UPI" });
        return false;
      }
      if (this.state.bankupiId == "") {
        this.setState({ errorbankupiId: "Please select" });
        return false;
      }
    }
    this.setState({
      nextEnterAmount: false,
      walletBalanceTab: false,
      winningBalanceTab: false,
      depositBalanceTab: false,
      paymentMethodTab: false,
      confirmDetailTab: true,
      selectupi: false,
      selectBank: true,
    });
  };
  nextEnterAmountFun = () => {
    this.setState({
      nextEnterAmount: true,
      walletBalanceTab: false,
      winningBalanceTab: false,
      depositBalanceTab: false,
    });
  };

  backNextEnterAmountFun = () => {
    this.setState({
      nextEnterAmount: true,
      walletBalanceTab: false,
      winningBalanceTab: false,
      depositBalanceTab: false,
      nextEnterKYC: false,
    });
  };

  paymentMethodFun = () => {
    if (this.state.amount == 0) {
      this.setState({ errorAmount: "Please enter amount" });
      return false;
    } else if (
      this.state.amount != 0 &&
      this.state.depositTab == 1 &&
      this.state.totalAvailableDeposit + this.state.totalAvailableWinning <
        this.state.amount
    ) {
      this.setState({ errorAmount: "Insufficient Balance" });
      return false;
    } else if (
      this.state.amount != 0 &&
      this.state.winningTab == 1 &&
      this.state.totalAvailableWinning < this.state.amount
    ) {
      this.setState({ errorAmount: "Insufficient Balance" });
      return false;
    } else {
      this.setState({
        nextEnterAmount: false,
        walletBalanceTab: false,
        paymentMethodTab: true,
        depositBalanceTab: false,
        winningBalanceTab: false,
        // selectupi: true,
        selectBank: true,
        nextEnterKYC: false,
      });
    }
  };
  backWalletBalanceFun = () => {
    this.setState({
      nextEnterAmount: false,
      walletBalanceTab: true,
      paymentMethodTab: false,
      depositBalanceTab: true,
      winningBalanceTab: false,
      nextEnterKYC: false,
    });
  };

  nextEnterKYCFun = () => {
    if (
      this.state.totalAvailableWinning + this.state.totalAvailableDeposit <
      this.state.amount
    ) {
      this.setState({ errorAmount: "Insufficient Balance" });
      return false;
    }
    if (this.state.amount == "") {
      this.setState({ errorAmount: "Plese enter amount" });
      return false;
    }
    this.setState({
      nextEnterAmount: false,
      nextEnterKYC: false,
      paymentMethodTab: true,
      depositBalanceTab: false,
      winningBalanceTab: false,
      // selectupi: true,
      selectBank: true,
      bankTransferTab: 1,
      upiTab: 0,
      errorAmount: "",
    });
  };
  KycConfrmFun = () => {
    this.setState({
      nextEnterAmount: false,
      nextEnterKYC: false,
      paymentMethodTab: true,
      // selectupi: true,
      selectBank: true,
    });
  };

  selectupiFun = () => {
    this.setState({
      selectupi: true,
      selectBank: false,
      bankTransferTab: 0,
      upiTab: 1,
    });
  };
  selectBankFun = () => {
    this.setState({
      selectupi: false,
      selectBank: true,
      bankTransferTab: 1,
      upiTab: 0,
    });
  };
  backEnterAmountFun = () => {
    this.setState({
      nextEnterAmount: true,
      walletBalanceTab: false,
      paymentMethodTab: false,
      selectupi: false,
      selectBank: false,
      nextEnterKYC: false,
    });
  };
  backtoEditUPI = () => {
    // console.log("editUPIData===");
    this.setState({
      nextEnterAmount: false,
      walletBalanceTab: false,
      paymentMethodTab: true,
      selectupi: true,
      selectBank: false,
      nextEnterKYC: false,
      bankTransferTab: 0,
      upiTab: 1,
      confirmDetailTab: false,
    });
  };
  backtoEditBANK = () => {
    this.setState({
      nextEnterAmount: false,
      walletBalanceTab: false,
      paymentMethodTab: true,
      selectupi: false,
      selectBank: true,
      nextEnterKYC: false,
      bankTransferTab: 1,
      upiTab: 0,
      confirmDetailTab: false,
    });
  };

  showAmountWithdrawalHtml = () => {
    let collectThis = this;
    // console.log("this.state.leaderboard", this.state.leaderboard);
    const html = [];
    html.push(
      <div className="table-responsive mb-3">
        <table className="table table-bordered mb-0">
          <tr>
            <th>Balance to be available</th>
            <th>Existing Balance</th>
            <th>Amount to withdraw</th>
            <th>TDS (30%)</th>
            <th>You will Receive</th>
            <th>Balance</th>
          </tr>
          <tr>
            <td>Available Winning Amount</td>
            <td>
              {Number(collectThis.state.totalAvailableWinning).toFixed(2)}
            </td>
            <td>
              {Number(collectThis.state.deductFromWinningAmount).toFixed(2)}
            </td>
            <td>{Number(collectThis.state.tdsDeduct).toFixed(2)}</td>
            <td>
              {Number(collectThis.state.reciveWithdrawalFromWinning).toFixed(2)}
            </td>
            <td>
              {Number(collectThis.state.totalRemainingWinning).toFixed(2)}
            </td>
          </tr>
          <tr>
            <td>Available Deposit Amount</td>
            <td>
              {Number(collectThis.state.totalAvailableDeposit).toFixed(2)}
            </td>
            <td>{Number(this.state.depositDeductAmount).toFixed(2)}</td>
            <td>0</td>
            <td>{Number(this.state.reciveWithdrawalFromDeposit).toFixed(2)}</td>
            <td>{Number(this.state.totalRemainingDeposit).toFixed(2)}</td>
          </tr>
        </table>
      </div>
    );
    //console.log("profitArr.includes(portfolioVal)",profitArr.includes(portfolioVal));
    return html;
  };
  maxAmountEnter = () => {
    let totalAmount = (
      Number(this.state.totalAvailableDeposit) +
      Number(this.state.totalAvailableWinning)
    ).toFixed(2);
    this.setState({ amount: totalAmount }, () => this.confrmAmountWinthdrwl());
  };

  confrmAmountWinthdrwl = () => {
    if (
      this.state.totalAvailableWinning + this.state.totalAvailableDeposit <
      this.state.amount
    ) {
      this.setState({ errorAmount: "Insufficient Balance" });
      return false;
    }

    if (this.state.totalAvailableWinning >= this.state.amount) {
      console.log("hii1");
      let winningBalanceDeduct = (Number(this.state.amount) * 30) / 100;
      // winningBalanceDeduct = winningBalanceDeduct.toFixed(2)*100;
      let reciveWithdrawalFromWinning =
        Number(this.state.amount) - Number(winningBalanceDeduct).toFixed(2);
      let totalRemainingWinning =
        this.state.totalAvailableWinning - Number(this.state.amount);

      this.setState({
        deductFromWinningAmount: this.state.amount,
        totalRemainingWinning: totalRemainingWinning,
        tdsDeduct: winningBalanceDeduct,
        reciveWithdrawalFromWinning: reciveWithdrawalFromWinning,
        depositDeductAmount: 0,
        reciveWithdrawalFromDeposit: 0,
        totalRemainingDeposit: this.state.totalAvailableDeposit,
        confirmPayment: true,
      });
    } else if (
      this.state.totalAvailableWinning + this.state.totalAvailableDeposit >=
      this.state.amount
    ) {
      console.log("hii2");
      let deductFromWiining =
        this.state.amount - this.state.totalAvailableWinning;
      let deductFromWiiningApplyTds = this.state.amount - deductFromWiining;
      let winningBalanceDeduct = (Number(deductFromWiiningApplyTds) * 30) / 100;
      // winningBalanceDeduct = winningBalanceDeduct.toFixed(2)*100;
      let reciveWithdrawalFromWinning =
        Number(deductFromWiiningApplyTds) -
        Number(winningBalanceDeduct).toFixed(2);
      let totalRemainingWinning =
        this.state.totalAvailableWinning - Number(deductFromWiining);

      // duduct from Deposit

      this.setState({
        deductFromWinningAmount: this.state.totalAvailableWinning,
        totalRemainingWinning: 0,
        tdsDeduct: winningBalanceDeduct,
        reciveWithdrawalFromWinning: reciveWithdrawalFromWinning,
        depositDeductAmount: deductFromWiining,
        reciveWithdrawalFromDeposit: deductFromWiining,
        totalRemainingDeposit:
          this.state.totalAvailableDeposit - deductFromWiining,
        confirmPayment: true,
      });
    }
  };
  stripePaymentmodal = () => {
    this.setState({ stripePayment: true });
  };

  getDecimalPlaces = (value) => {
    const match = value.match(/\.(\d*)$/);
    return match ? match[1].length : 0;
  };
  truncateDecimals = (value, decimalPlaces) => {
    const factor = Math.pow(10, decimalPlaces);
    return Math.trunc(value * factor) / factor;
  };

  onChange = (e) => {
    if (e.target.id === "fname") {
      this.setState({
        fname: e.target.value,
        errorfname: "",
      });
    }
    if (e.target.id === "mname") {
      this.setState({
        mname: e.target.value,
        errormname: "",
      });
    }
    if (e.target.id === "lname") {
      this.setState({
        lname: e.target.value,
        errorlname: "",
      });
    }
    if (e.target.id === "dob") {
      this.setState({
        dob: e.target.value,
        errordob: "",
      });
    }
    if (e.target.id === "country") {
      this.setState({
        country: e.target.value,
        errorcountry: "",
      });
    }

    if (e.target.id === "amount") {
      const value = e.target.value;
      // Remove any non-digit and non-decimal characters from the input
      const cleanedValue = value.replace(/[^0-9.]/g, "");
      // Check if the cleaned value exceeds two decimal places
      const decimalPlaces = this.getDecimalPlaces(cleanedValue);
      const truncatedValue = this.truncateDecimals(cleanedValue, 2);
      if (decimalPlaces > 2) {
        // Truncate the decimal places to two
        this.setState(
          {
            amount: truncatedValue,

            errorAmount: "Only two decimal places are allowed.",
          },
          () => this.confrmAmountWinthdrwl()
        );
      } else {
        this.setState(
          {
            amount: cleanedValue,

            errorAmount: "",
          },
          () => this.confrmAmountWinthdrwl()
        );
      }
    }

    if (e.target.id === "upiId") {
      this.setState({
        upiId: e.target.value,
        errorupiId: "",
      });
    }
    if (e.target.id === "bankupiId") {
      console.log("dfsdfsdfsd===", e.target.value);
      this.setState({
        bankupiId: e.target.value,
        errorbankupiId: "",
      });
    }
    if (e.target.id === "accountHolderNumber") {
      this.setState({
        accountHolderNumber: e.target.value,
        erroraccountHolderNumber: "",
      });
    }
    if (e.target.id === "accountNumber") {
      if (/^[0-9]{8,16}$/.test(e.target.value)) {
        this.setState({
          accountNumber: e.target.value,
          erroraccountNumber: "",
        });
      } else {
        this.setState({
          erroraccountNumber: "Account number invalid",
        });
      }
    }
    if (e.target.id === "confrmaccount") {
      if (/^[0-9]{8,16}$/.test(e.target.value)) {
        this.setState({
          confrmaccount: e.target.value,
          errorconfrmaccount: "",
        });
      } else {
        this.setState({
          errorconfrmaccount: "Account number invalid",
        });
      }
    }
    if (e.target.id === "bankName") {
      this.setState({
        bankName: e.target.value,
        errorbankName: "",
      });
    }
    if (e.target.id === "ifscCode") {
      this.setState({
        ifscCode: e.target.value,
      });
      let regex = new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);
      if (regex.test(e.target.value) == true) {
        this.setState({
          errorifscCode: "",
        });
      } else {
        this.setState({
          errorifscCode: "Please enter valid IFSC Code",
        });
      }
    }
    if (e.target.id === "bankAddress") {
      this.setState({
        bankAddress: e.target.value,
        errorbankAddress: "",
      });
    }
    if (e.target.name === "attachment") {
      var attachment = e.target.files[0];
      var fileSize = e.target.files[0].size;
      if (fileSize > 5000000) {
        this.setState({
          errorAttachment: "Maximum 5 MB Image allowed.",
          firstSubmitIsDisabled: true,
          userUploadImage: false,
        });
        return false;
      }
      if (!attachment.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        this.setState({
          errorAttachment: "Please select valid Front image jpeg,png,gif.",
          firstSubmitIsDisabled: true,
          userUploadImage: false,
        });
        return false;
      }
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.setState({ mobileAttachment: reader.result });
        // console.log("reader.result=========",reader.result); //base64encoded string
      };
      this.setState({
        logo: attachment,
        thumnailLogo: URL.createObjectURL(e.target.files[0]),
        errorAttachment: "",
      });
    }
    this.setState({ [e.target.id]: e.target.value });
    // this.setState({ [e.target.id]: e.target.value });
  };
  getBranchName = () => {
    if (this.state.ifscCode === "") {
      this.setState({
        errorifscCode: "Please enter IFSC Code",
      });
      return false;
    }
    this.setState({ loadingProcess: true });
    axios
      .post(
        baseUrl + "api/fetchIfscCode",
        { ifscCode: this.state.ifscCode },
        configToken
      )
      .then((res) => {
        console.log("resres===", res);
        if (res.data) {
          if (res.data.data == "" && res.data.status == false) {
            this.setState({
              loadingProcess: false,
              bankAddress: "",
              errorifscCode: "Please enter valid IFSC Code",
              bankTransferTab: 1,
              selectBank: true,
            });
            toast.error("Please enter valid IFSC Code", toastStyles);
            return false;
          } else {
            this.setState({
              loadingProcess: false,
              bankAddress: res.data.ADDRESS,
              errorifscCode: "",
              bankTransferTab: 1,
              selectBank: true,
            });
          }
        }
      });
  };
  // kyc Info Data
  addKYCInfo = (e) => {
    e.preventDefault();
    console.log("KYCU");
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    if (typeof this.state.fname == "undefined" || this.state.fname == "") {
      toast.error("Please enter frist name", toastStyles);
      return false;
    }
    if (typeof this.state.lname == "undefined" || this.state.lname == "") {
      toast.error("Please enter last name", toastStyles);
      return false;
    }
    if (typeof this.state.dob == "undefined" || this.state.dob == "") {
      toast.error("Please enter date of birth", toastStyles);
      return false;
    }

    let newData = {
      fname: this.state.fname,
      upiId: this.state.mname,
      lname: this.state.lname,
      dob: this.state.dob,
    };

    axios.post(baseUrl + "api/kyc-upload", newData, configToken).then((res) => {
      // console.log("kyc-upload======",res.data.data.ars.data.url);
      if (
        res.data &&
        res.data.data &&
        res.data.data.ars &&
        res.data.data.ars.data &&
        res.data.data.ars.data.url
      ) {
        this.setState({ urlKycUpload: res.data.data.ars.data.url });
      }
    });
  };
  // Kyc Verify End
  addrequest = (e) => {
    e.preventDefault();
    // console.log("dataRequest==========");
    this.setState({ disabledButton: true });
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    if (this.state.amount === "" || this.state.amount === undefined) {
      this.setState({
        errorAmount: "Please enter amount",
      });
      return false;
    }
    if (this.state.amount < 100) {
      toast.error("Minimum withdrawal is ₹ 100", toastStyles);
      return false;
    }
    if (this.state.bankTransferTab == 1) {
      if (this.state.accountHolderNumber == "") {
        this.setState({
          erroraccountHolderNumber: "Please enter account holder name",
        });
        return false;
      }
      if (this.state.accountNumber == "") {
        this.setState({ erroraccountNumber: "Please enter account no" });
        return false;
      }
      if (this.state.bankName == "") {
        this.setState({ errorbankName: "Please enter bank name" });
        return false;
      }
      if (this.state.ifscCode == "") {
        this.setState({ errorifscCode: "Please enter IFSC Code" });
        return false;
      }
      if (this.state.bankAddress == "") {
        this.setState({ errorbankAddress: "Please enter bank address" });
        return false;
      }
      // if (this.state.bankAttchment == "") {
      //   this.setState({ errorbankAttchment: "Please select" });
      //   return false;
      // }
    } else if (this.state.upiTab == 1) {
      if (this.state.upiId == "") {
        this.setState({ errorupiId: "Please enter UPI" });
        return false;
      }
      if (this.state.bankupiId == "") {
        this.setState({ errorbankupiId: "Please select" });
        return false;
      }
    }
    console.log("dataa-notFound");

    if (localStorage.getItem("source") == "mobile") {
      let newData = {
        amount: this.state.amount,
        upiId: this.state.upiId + this.state.bankupiId,
        accountHolderNumber: this.state.accountHolderNumber,
        accountNumber: this.state.accountNumber,
        bankName: this.state.bankName,
        ifscCode: this.state.ifscCode,
        bankAddress: this.state.bankAddress,
        depositTab: this.state.depositTab,
        winningTab: this.state.winningTab,
        bankAttchment: this.state.mobileAttachment,
        upiTab: this.state.upiTab,
        bankTransferTab: this.state.bankTransferTab,
        existAttachment: this.state.existAttachment,
      };
      axios
        .post(
          baseUrl + "api/add-request-withdrawal-cash-mobile",
          newData,
          configToken
        )
        .then((res) => {
          if (res.data.success) {
            toast.success(res.data.message, toastStyles);
            var urltemp = "";
            if (
              localStorage.getItem("source") !== "" &&
              localStorage.getItem("theme") !== ""
            ) {
              urltemp =
                "?source=" +
                localStorage.getItem("source") +
                "&theme=" +
                localStorage.getItem("theme");
              // console.log("urlStamp==",urltemp);
              this.setState({
                urltemp: urltemp,
                themeSet: localStorage.getItem("theme"),
              });
            }
            setTimeout(() => {
              window.location.href = "/addCash" + urltemp;
            }, 1000);
          } else {
            toast.error(res.data.message, toastStyles);
            var urltemp = "";
            if (
              localStorage.getItem("source") !== "" &&
              localStorage.getItem("theme") !== ""
            ) {
              urltemp =
                "?source=" +
                localStorage.getItem("source") +
                "&theme=" +
                localStorage.getItem("theme");
              // console.log("urlStamp==",urltemp);
              this.setState({
                urltemp: urltemp,
                themeSet: localStorage.getItem("theme"),
              });
            }
            setTimeout(() => {
              window.location.href = "/addCash" + urltemp;
            }, 1000);
          }
          // this.setState({ cashWalletRecords: res.data.data })
        })
        .catch();
    } else {
      // console.log("data-addAmount");
      const formData = new FormData();
      formData.append("amount", this.state.amount);
      formData.append("upiId", this.state.upiId + this.state.bankupiId);
      formData.append("accountHolderNumber", this.state.accountHolderNumber);
      formData.append("accountNumber", this.state.accountNumber);
      formData.append("bankName", this.state.bankName);
      formData.append("ifscCode", this.state.ifscCode);
      formData.append("bankAddress", this.state.bankAddress);
      formData.append("depositTab", this.state.depositTab);
      formData.append("winningTab", this.state.winningTab);
      formData.append("bankAttchment", this.state.logo);
      formData.append("upiTab", this.state.upiTab);
      formData.append("bankTransferTab", this.state.bankTransferTab);
      formData.append("existAttachment", this.state.existAttachment);
      console.log("formData=", formData);
      this.props.withrawalRequest(formData, config);
    }
  };

  pageChange(pageData) {
    // console.log("OnPageChange", pageData);
  }

  render() {
    const { errors1, loadingProcess } = this.state;
    // if (loadingProcess) {
    //   return <Loading themeSet={this.state.themeSet} />;
    // }
    return (
      <>
        {this.state.loadingProcess && (
          <Loading themeSet={this.state.themeSet} />
        )}

        <Navbar urlPath={true} symbol={false} />
        <Sidebar />
        <div className="container container2">
          <div className=" padding_d in_page">
            <ul id="progressbar">
              <li className={this.state.nextEnterKYC ? "active" : ""} id="kyc">
                <strong>KYC Confirmation</strong>
              </li>
              <li
                className={this.state.walletBalanceTab ? "active" : ""}
                id="account"
              >
                <strong>Wallet Balance</strong>
              </li>
              <li
                className={this.state.nextEnterAmount ? "active" : ""}
                id="personal"
              >
                <strong>Enter Amount</strong>
              </li>
              <li
                className={this.state.paymentMethodTab ? "active" : ""}
                id="payment"
              >
                <strong>Payment Method</strong>
              </li>
              <li
                className={this.state.confirmDetailTab ? "active" : ""}
                id="payment"
              >
                <strong>Confirm Details</strong>
              </li>
            </ul>
            <div className="tab-content">
              <div className="white_box ">
                {/* KYC Enter */}
                {this.state.kyc_verification !== "completed" &&
                  this.state.nextEnterKYC && (
                    <>
                      <form noValidate onSubmit={this.addKYCInfo}>
                        <div className="row">
                          {(this.state.kyc_verification == "pending" ||
                            this.state.kyc_verification == "pending") &&
                            this.state.urlKycUpload == "" && (
                              <div className=" col-md-7 col-12 m-auto mb-5">
                                <div class="form-group">
                                  <label>
                                    First Name
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Enter Your First Name"
                                    class="form-control"
                                    id="fname"
                                    onChange={this.onChange}
                                    value={this.state.fname}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Middle Name</label>
                                  <input
                                    formcontrolname="mbsMName"
                                    type="text"
                                    autocomplete="off"
                                    placeholder="Enter Your Middle Name"
                                    class="form-control"
                                    id="mname"
                                    onChange={this.onChange}
                                    value={this.state.mname}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>
                                    Last Name
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    maxlength="20"
                                    formcontrolname="mbsLName"
                                    type="text"
                                    autocomplete="off"
                                    placeholder="Enter Your Last Name"
                                    class="form-control"
                                    id="lname"
                                    onChange={this.onChange}
                                    value={this.state.lname}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>
                                    Date of Birth
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <input
                                    type="date"
                                    name="mydate"
                                    formcontrolname="mbsDOB"
                                    placeholder="dd-mm-yyyy"
                                    class="form-control"
                                    id="dob"
                                    onChange={this.onChange}
                                    value={this.state.dob}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>
                                    Country
                                    <span className="text-danger"> *</span>
                                  </label>
                                  <select
                                    class="form-control"
                                    id="country"
                                    readOnly={true}
                                    onChange={this.onChange}
                                  >
                                    <option value="IN"> India </option>
                                  </select>
                                </div>
                                <button type="submit" class="btn_man">
                                  Complete Your KYC
                                </button>
                              </div>
                            )}
                          {this.state.urlKycUpload != "" && (
                            <iframe
                              src={this.state.urlKycUpload}
                              width="800"
                              height="600"
                              title="External Website"
                            ></iframe>
                          )}

                          {this.state.kyc_verification === "inprogress" && (
                            <>
                              {/* <div className="row"> */}
                              <div className=" col-md-12 m-auto mb-5">
                                <div class="kyc_process_box text-center p-2 p-md-4">
                                  <p className="mb-4">
                                    {" "}
                                    <b>
                                      To process withdrawal request you must
                                      complete KYC.
                                    </b>{" "}
                                  </p>
                                  <p className="mb-4">
                                    Your KYC Status: <b> In Progress</b>{" "}
                                  </p>
                                  <button type="button" class="btn_man mb-3">
                                    <a href={"/addCash" + this.state.urltemp}>
                                      Close
                                    </a>
                                  </button>
                                </div>
                              </div>
                              {/* </div> */}
                            </>
                          )}
                          {/* <div className=" col-md-7 col-12 m-auto mb-5">
                        <div className="form-group mt-5">
                          <div className="progress">
                            <div
                              className="progress-bar progress-bar-striped progress-bar-animated"
                              style={{ width: "40%" }}
                            />                        
                          </div>
                          <p className="text-center">Progress</p>
                        </div>
                      </div> */}
                        </div>
                      </form>
                      {this.state.urlKycUpload == "" &&
                        this.state.kyc_verification == "completed" && (
                          <div className="d-flex">
                            <button
                              type="button"
                              className="btn-primary  btn "
                              onClick={this.backNextEnterAmountFun}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className="btn_man btn ml-auto"
                              onClick={this.KycConfrmFun}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      <hr />
                    </>
                  )}

                {/* ----- new Screen----------*/}
                {/* <div className="row">
                        <div className=" col-md-8 m-auto mb-5">
                          <div class="kyc_process_box text-center p-2 p-md-4">
                            <p className="mb-4"> <b>To process withdrawal request you must complete KYC.</b> </p>
                               <p className="mb-4">Your KYC Status: <b> Pending</b> </p>

                          <button type="submit" class="btn_man mb-3">
                            Initiate KYC Process
                          </button>
                          </div>                          
                        </div>                        
                      
                     
                      
                      
                                           
                      </div> */}

                {/* ----- new Screen----------*/}
                <form onSubmit={this.addrequest}>
                  {this.state.walletBalanceTab && (
                    <>
                      <h4 className=" mb-3 text-center">
                        <b>
                          Wallet Balance{" "}
                          {(
                            Number(this.state.cashWalletBalance) +
                            Number(this.state.winningCashAmount)
                          ).toFixed(2)}
                        </b>
                      </h4>
                      <div className="text-center">
                        <div className="d-inline-flex mb-4">
                          <div className="form-check check_box">
                            <label className="form-check-label">
                              {/* <input type="radio" id="Deposit-Balance" name="select-Balance" checked={this.state.depositBalanceTab ? "checked" : ""} onClick={this.depositBalance} /> <br />  */}
                              Deposit Balance
                              <br />
                              {this.state.totalAvailableDeposit != null
                                ? this.state.totalAvailableDeposit.toFixed(2)
                                : 0}
                            </label>
                          </div>
                          <div className="form-check check_box">
                            <label className="form-check-label">
                              {/* <input type="radio" id="Winning Balance " name="select-Balance" checked={this.state.winningBalanceTab ? "checked" : ""} onClick={this.winningBalance} />  <br /> */}
                              Winning Balance
                              <br />
                              {this.state.totalAvailableWinning != null &&
                              typeof this.state.totalAvailableWinning !=
                                "undefined"
                                ? this.state.totalAvailableWinning.toFixed(2)
                                : 0}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn_man btn ml-auto"
                          onClick={this.nextEnterAmountFun}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {/* {this.state.depositBalanceTab && <><div className="row">
                    <div className="m-auto col-md-6">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Deposit Amount </th>
                            <th>{this.state.totalDeposit}</th>
                          </tr>
                          <tr>
                            <th>Used Amount </th>
                            <th>{this.state.totalUsedCash + this.state.totalusedcashwallet}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div><div className="d-flex">
                      <button type="button" className="btn_man btn ml-auto" onClick={this.nextEnterAmountFun}>Next</button>
                    </div></>} */}

                  {/* {this.state.winningBalanceTab && <><div className="row">
                    <div className="m-auto col-md-6">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <th>Winning Amount </th>
                            <th>{(this.state.totalWinning != null && typeof this.state.totalWinning != 'undefined') ? this.state.totalWinning.toFixed(2) : 0}</th>
                          </tr>
                          <tr>
                            <th>Used Amount </th>
                            <th>{(this.state.totalUsedWinning + this.state.totalusedwinningwallet).toFixed(2)}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                    <div className="d-flex">
                      <button type="submit" className="btn_man btn ml-auto" onClick={this.nextEnterAmountFun}>Next</button>
                    </div>
                  </>
                  } */}

                  {this.state.nextEnterAmount && (
                    <>
                      <h4 className=" mb-4 text-center">
                        <b>
                          Available Balance{" "}
                          {this.state.totalAvailableDeposit != null
                            ? this.state.totalAvailableWinning != null &&
                              typeof this.state.totalAvailableWinning !=
                                "undefined"
                              ? (
                                  Number(this.state.totalAvailableWinning) +
                                  Number(this.state.totalAvailableDeposit)
                                ).toFixed(2)
                              : Number(
                                  this.state.totalAvailableDeposit
                                ).toFixed(2)
                            : 0}
                        </b>
                      </h4>
                      <div className="row">
                        <div className="form-group col-md-3 col-12">
                          <label>Amount To Withdraw </label>
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <div className="input-group">
                            <input
                              id="amount"
                              type="text"
                              className="form-control"
                              onChange={this.onChange}
                              placeholder="Amount to withdraw"
                              value={this.state.amount}
                            />
                            <div className="input-group-append text-center ">
                              <span
                                className="text-primary input-group-text input-group-text2"
                                onClick={this.maxAmountEnter}
                              >
                                {" "}
                                Max
                              </span>
                            </div>
                          </div>
                          <span className="text-danger">
                            {this.state.errorAmount}
                          </span>
                          {this.state.winningTab == 1 && (
                            <div className="text-right">
                              TDS: 30% &nbsp;&nbsp;&nbsp;Deduct Amount:{" "}
                              {this.state.amount != 0 &&
                              this.state.winningTab == 1
                                ? ((this.state.amount * 30) / 100).toFixed(2)
                                : 0}
                            </div>
                          )}
                        </div>
                        <div className="form-group col-md-3 col-12">
                          <button
                            type="button"
                            className="btn_man btn ml-auto"
                            onClick={this.confrmAmountWinthdrwl}
                          >
                            Show Detail
                          </button>
                        </div>
                        {/* <div className="form-group col-md-6 col-12">
                        <label>Transferable Amount</label>
                        <input id="" type="text" className="form-control" value={this.state.amount != 0 && this.state.winningTab == 1 ? (this.state.amount - this.state.amount * 30 / 100).toFixed(2) : this.state.amount} readOnly={true} />
                      </div> */}
                      </div>
                      {/* {this.state.confirmPayment && ( */}
                      <div className="row">
                        <div className="form-group col-md-12 col-12">
                          {this.showAmountWithdrawalHtml()}
                          <span>
                            * 30% TDS deduction will be applicable only on
                            Winning Amount
                          </span>
                        </div>
                      </div>
                      {/* )} */}

                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn-primary  btn "
                          onClick={this.backWalletBalanceFun}
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          className="btn_man btn ml-auto"
                          onClick={this.nextEnterKYCFun}
                        >
                          Confirm{" "}
                        </button>
                      </div>
                      <hr />
                    </>
                  )}

                  {this.state.paymentMethodTab && (
                    <>
                      <h5 className=" mb-3 text-center">
                        <b>How would you like to receive your payment? </b>
                      </h5>
                      <div className="text-center">
                        <div className="form-check check_box">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className=""
                              name="tranferMethod"
                              checked={this.state.selectupi ? "checked" : ""}
                              onClick={this.selectupiFun}
                            />{" "}
                            <br /> UPI
                          </label>
                        </div>
                        <div className="form-check check_box">
                          <label className="form-check-label">
                            <input
                              type="radio"
                              className=""
                              name="tranferMethod"
                              checked={this.state.selectBank ? "checked" : ""}
                              onClick={this.selectBankFun}
                            />{" "}
                            <br />
                            Bank Transfer
                          </label>
                        </div>
                      </div>
                    </>
                  )}
                  {!this.state.confirmDetailTab && this.state.selectupi && (
                    <>
                      <div className="row">
                        <div className="form-group col-md-6 col-12">
                          <label>UPI ID</label>
                          <input
                            id="upiId"
                            type="text"
                            className="form-control"
                            value={this.state.upiId}
                            onChange={this.onChange}
                          />
                          <span className="text-danger">
                            {this.state.errorupiId}
                          </span>
                          <br />
                          <span className="text-danger">
                            (Double check your entered UPI ID, as wrong UPI ID
                            can risk your funds to be lost completely)
                          </span>
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>Bank</label>
                          <select
                            className="form-control"
                            value={this.state.bankupiId}
                            onChange={this.onChange}
                            id="bankupiId"
                          >
                            <option value="">@All Banks</option>
                            <option value="@Sbi">@Sbi</option>
                            <option value="@imobile">@imobile</option>
                            <option value="@pockets">@pockets</option>
                            <option value="@ezeepay">@ezeepay</option>
                            <option value="@icici">@icici</option>
                            <option value="@okicici">@okicici</option>
                            <option value="@hdfcbank">@hdfcbank</option>
                            <option value="@payzapp">@payzapp</option>
                            <option value="@okhdfcbank">@okhdfcbank</option>
                            <option value="@rajgovhdfcbank">
                              @rajgovhdfcbank
                            </option>
                            <option value="@mahb">@mahb</option>
                            <option value="@kotak">@kotak</option>
                            <option value="@kaypay">@kaypay</option>
                            <option value="@kmb">@kmb</option>
                            <option value="@kmbl">@kmbl</option>
                            <option value="@Yesbank">@Yesbank</option>
                            <option value="@yesbankltd">@yesbankltd</option>
                            <option value="@Ubi">@Ubi</option>
                            <option value="@united">@united</option>
                            <option value="@utbi">@utbi</option>
                            <option value="@Idbi">@Idbi</option>
                            <option value="@idbibank">@idbibank</option>
                            <option value="@hsbc">@hsbc</option>
                            <option value="@pnb">@pnb</option>
                            <option value="@centralbank">@centralbank</option>
                            <option value="@cbin">@cbin</option>
                            <option value="@cboi">@cboi</option>
                            <option value="@cnrb">@cnrb</option>
                            <option value="@barodampay">@barodampay</option>
                          </select>
                          <span className="text-danger">
                            {this.state.errorbankupiId}
                          </span>
                        </div>
                      </div>

                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn-primary  btn"
                          onClick={this.backEnterAmountFun}
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          className="btn_man btn ml-auto"
                          onClick={this.confirmDetailTabFun}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}

                  {!this.state.confirmDetailTab && this.state.selectBank && (
                    <>
                      <h5 className=" mb-3 ">
                        <b>Bank Detail </b>
                      </h5>

                      <div className="row">
                        <div className="form-group col-md-6 col-12">
                          <label>
                            Name of the beneficiary
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            id="accountHolderNumber"
                            type="text"
                            className="form-control"
                            value={this.state.accountHolderNumber}
                            onChange={this.onChange}
                          />
                          <span className="text-danger">
                            {this.state.erroraccountHolderNumber}
                          </span>
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>
                            Bank Account No.
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            id="accountNumber"
                            type="text"
                            className="form-control"
                            value={this.state.accountNumber}
                            onChange={this.onChange}
                          />
                          <span className="text-danger">
                            {this.state.erroraccountNumber}
                          </span>
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>
                            Confirm Bank Account No.
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            id="confrmaccount"
                            type="text"
                            className="form-control"
                            value={this.state.accountNumber}
                            onChange={this.onChange}
                          />
                          <span className="text-danger">
                            {this.state.errorconfrmaccount}
                          </span>
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>
                            Bank Name<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            value={this.state.bankName}
                            onChange={this.onChange}
                            id="bankName"
                          >
                            <option value="">select</option>
                            <option value="Aditya Birla Idea Payments Bank Ltd">
                              Aditya Birla Idea Payments Bank Ltd
                            </option>
                            <option value="Airtel Payments Bank Ltd">
                              Airtel Payments Bank Ltd
                            </option>
                            <option value="Andhra Pradesh GVB">
                              Andhra Pradesh GVB
                            </option>
                            <option value="Andhra Pragathi Grameena Bank">
                              Andhra Pragathi Grameena Bank
                            </option>
                            <option value="Arunachal Pradesh Rural Bank">
                              Arunachal Pradesh Rural Bank
                            </option>
                            <option value="Aryavart Bank">Aryavart Bank</option>
                            <option value="Assam Gramin Vikash Bank">
                              Assam Gramin Vikash Bank
                            </option>
                            <option value="Au Small Finance Bank Ltd">
                              Au Small Finance Bank Ltd
                            </option>
                            <option value="Axis Bank Ltd">Axis Bank Ltd</option>
                            <option value="Bandhan Bank Ltd">
                              Bandhan Bank Ltd
                            </option>
                            <option value="Bangiya Gramin Vikash Bank">
                              Bangiya Gramin Vikash Bank
                            </option>
                            <option value="Bank of Baroda">
                              Bank of Baroda
                            </option>
                            <option value="Bank of India">Bank of India</option>
                            <option value="Bank of Maharashtra">
                              Bank of Maharashtra
                            </option>
                            <option value="Baroda Gujarat Gramin Bank">
                              Baroda Gujarat Gramin Bank
                            </option>
                            <option value="Baroda Rajasthan Kshetriya Gramin Bank">
                              Baroda Rajasthan Kshetriya Gramin Bank
                            </option>
                            <option value="Baroda Uttar Pradesh Gramin Bank">
                              Baroda Uttar Pradesh Gramin Bank
                            </option>
                            <option value="Canara Bank">Canara Bank</option>
                            <option value="Capital Small Finance Bank Ltd">
                              Capital Small Finance Bank Ltd
                            </option>
                            <option value="Central Bank of India">
                              Central Bank of India
                            </option>
                            <option value="Chaitanya Godavari GB">
                              Chaitanya Godavari GB
                            </option>
                            <option value="Chhattisgarh Rajya Gramin Bank">
                              Chhattisgarh Rajya Gramin Bank
                            </option>
                            <option value="City Union Bank Ltd">
                              City Union Bank Ltd
                            </option>
                            <option value="Coastal Local Area Bank Ltd">
                              Coastal Local Area Bank Ltd
                            </option>
                            <option value="CSB Bank Limited">
                              CSB Bank Limited
                            </option>
                            <option value="Dakshin Bihar Gramin Bank">
                              Dakshin Bihar Gramin Bank
                            </option>
                            <option value="DCB Bank Ltd">DCB Bank Ltd</option>
                            <option value="Dhanlaxmi Bank Ltd">
                              Dhanlaxmi Bank Ltd
                            </option>
                            <option value="Ellaquai Dehati Bank">
                              Ellaquai Dehati Bank
                            </option>
                            <option value="Equitas Small Finance Bank Ltd">
                              Equitas Small Finance Bank Ltd
                            </option>
                            <option value="ESAF Small Finance Bank Ltd">
                              ESAF Small Finance Bank Ltd
                            </option>
                            <option value="Export-Import Bank of India">
                              Export-Import Bank of India
                            </option>
                            <option value="Federal Bank Ltd">
                              Federal Bank Ltd
                            </option>
                            <option value="Fincare Small Finance Bank Ltd">
                              Fincare Small Finance Bank Ltd
                            </option>
                            <option value="Fino Payments Bank Ltd">
                              Fino Payments Bank Ltd
                            </option>
                            <option value="HDFC Bank Ltd">HDFC Bank Ltd</option>
                            <option value="Himachal Pradesh Gramin Bank">
                              Himachal Pradesh Gramin Bank
                            </option>
                            <option value="ICICI Bank Ltd">
                              ICICI Bank Ltd
                            </option>
                            <option value="IDBI Bank Limited">
                              IDBI Bank Limited
                            </option>
                            <option value="IDFC FIRST Bank Limited<">
                              IDFC FIRST Bank Limited
                            </option>
                            <option value="India Post Payments Bank Ltd">
                              India Post Payments Bank Ltd
                            </option>
                            <option value="Indian Bank">Indian Bank</option>
                            <option value="Indian Overseas Bank">
                              Indian Overseas Bank
                            </option>
                            <option value="IndusInd Bank Ltd">
                              IndusInd Bank Ltd
                            </option>
                            <option value="J&K Grameen Bank">
                              J&K Grameen Bank
                            </option>
                            <option value="Jammu & Kashmir Bank Ltd">
                              Jammu & Kashmir Bank Ltd
                            </option>
                            <option value="Jana Small Finance Bank Ltd">
                              Jana Small Finance Bank Ltd
                            </option>
                            <option value="Jharkhand Rajya Gramin Bank">
                              Jharkhand Rajya Gramin Bank
                            </option>
                            <option value="Jio Payments Bank Ltd">
                              Jio Payments Bank Ltd
                            </option>
                            <option value="Karnataka Bank Ltd">
                              Karnataka Bank Ltd
                            </option>
                            <option value="Karnataka Gramin Bank">
                              Karnataka Gramin Bank
                            </option>
                            <option value="Karnataka Vikas Gramin Bank">
                              Karnataka Vikas Gramin Bank
                            </option>
                            <option value="Karur Vysya Bank Ltd">
                              Karur Vysya Bank Ltd
                            </option>
                            <option value="Kashi Gomti Samyut Gramin Bank">
                              Kashi Gomti Samyut Gramin Bank
                            </option>
                            <option value="Kerala Gramin Bank">
                              Kerala Gramin Bank
                            </option>
                            <option value="Kotak Mahindra Bank Ltd">
                              Kotak Mahindra Bank Ltd
                            </option>
                            <option value="Krishna Bhima Samruddhi LAB Ltd">
                              Krishna Bhima Samruddhi LAB Ltd
                            </option>
                            <option value="Lakshmi Vilas Bank Ltd">
                              Lakshmi Vilas Bank Ltd
                            </option>
                            <option value="Madhya Pradesh Gramin Bank">
                              Madhya Pradesh Gramin Bank
                            </option>
                            <option value="Madhyanchal Gramin Bank">
                              Madhyanchal Gramin Bank
                            </option>
                            <option value="Maharashtra GB">
                              Maharashtra GB
                            </option>
                            <option value="Manipur Rural Bank">
                              Manipur Rural Bank
                            </option>
                            <option value="Meghalaya Rural Bank">
                              Meghalaya Rural Bank
                            </option>
                            <option value="Mizoram Rural Bank">
                              Mizoram Rural Bank
                            </option>
                            <option value="Nagaland Rural Bank">
                              Nagaland Rural Bank
                            </option>
                            <option value="Nainital Bank Ltd">
                              Nainital Bank Ltd
                            </option>
                            <option value="National Bank for Agriculture and Rural Development">
                              National Bank for Agriculture and Rural
                              Development
                            </option>
                            <option value="National Housing Bank">
                              National Housing Bank
                            </option>
                            <option value="North East Small Finance Bank Ltd">
                              North East Small Finance Bank Ltd
                            </option>
                            <option value="NSDL Payments Bank Limited">
                              NSDL Payments Bank Limited
                            </option>
                            <option value="Odisha Gramya Bank">
                              Odisha Gramya Bank
                            </option>
                            <option value="Paschim Banga Gramin Bank">
                              Paschim Banga Gramin Bank
                            </option>
                            <option value="Paytm Payments Bank Ltd">
                              Paytm Payments Bank Ltd
                            </option>
                            <option value="Prathama U.P. Gramin Bank">
                              Prathama U.P. Gramin Bank
                            </option>
                            <option value="Puduvai Bharathiar Grama Bank">
                              Puduvai Bharathiar Grama Bank
                            </option>
                            <option value="Punjab & Sind Bank">
                              Punjab & Sind Bank
                            </option>
                            <option value="Punjab Gramin Bank">
                              Punjab Gramin Bank
                            </option>
                            <option value="Punjab National Bank">
                              Punjab National Bank
                            </option>
                            <option value="Purvanchal Bank">
                              Purvanchal Bank
                            </option>
                            <option value="Rajasthan Marudhara Gramin Bank">
                              Rajasthan Marudhara Gramin Bank
                            </option>
                            <option value="RBL Bank Ltd">RBL Bank Ltd</option>
                            <option value="Saptagiri Grameena Bank">
                              Saptagiri Grameena Bank
                            </option>
                            <option value="Sarva Haryana Gramin Bank">
                              Sarva Haryana Gramin Bank
                            </option>
                            <option value="Saurashtra Gramin Bank">
                              Saurashtra Gramin Bank
                            </option>
                            <option value="Small Industries Development Bank of India">
                              Small Industries Development Bank of India
                            </option>
                            <option value="South Indian Bank Ltd">
                              South Indian Bank Ltd
                            </option>
                            <option value="State Bank of India">
                              State Bank of India
                            </option>
                            <option value="Subhadra Local Bank Ltd">
                              Subhadra Local Bank Ltd
                            </option>
                            <option value="Suryoday Small Finance Bank Ltd">
                              Suryoday Small Finance Bank Ltd
                            </option>
                            <option value="Tamil Nadu Grama Bank">
                              Tamil Nadu Grama Bank
                            </option>
                            <option value="Tamilnad Mercantile Bank Ltd">
                              Tamilnad Mercantile Bank Ltd
                            </option>
                            <option value="Telangana Grameena Bank">
                              Telangana Grameena Bank
                            </option>
                            <option value="Tripura Gramin Bank">
                              Tripura Gramin Bank
                            </option>
                            <option value="UCO Bank">UCO Bank</option>
                            <option value="Ujjivan Small Finance Bank Ltd">
                              Ujjivan Small Finance Bank Ltd
                            </option>
                            <option value="Union Bank of India">
                              Union Bank of India
                            </option>
                            <option value="Utkal Grameen Bank">
                              Utkal Grameen Bank
                            </option>
                            <option value="Utkarsh Small Finance Bank Ltd">
                              Utkarsh Small Finance Bank Ltd
                            </option>
                            <option value="Uttar Bihar Gramin Bank">
                              Uttar Bihar Gramin Bank
                            </option>
                            <option value="Uttarakhand Gramin Bank">
                              Uttarakhand Gramin Bank
                            </option>
                            <option value="Uttar Banga Kshetriya Gramin Bank">
                              Uttar Banga Kshetriya Gramin Bank
                            </option>
                            <option value="Vidharbha Konkan Gramin Bank">
                              Vidharbha Konkan Gramin Bank
                            </option>
                            <option value="YES Bank Ltd">YES Bank Ltd</option>
                          </select>
                          <span className="text-danger">
                            {this.state.errorbankName}
                          </span>
                        </div>
                        <div className="form-group col-md-6 col-12">
                          <label>
                            IFSC Code<span className="text-danger">*</span>
                          </label>
                          <div className="verifi_box">
                            <input
                              id="ifscCode"
                              type="text"
                              className="form-control"
                              value={this.state.ifscCode}
                              onChange={this.onChange}
                            />

                            {this.state.bankAddress == "" && (
                              <span
                                className="btn btn-danger verifi_button"
                                onClick={this.getBranchName}
                              >
                                Verify
                              </span>
                            )}
                            {this.state.bankAddress != "" && (
                              <span
                                className="btn btn-success verifi_button"
                                onClick={this.getBranchName}
                              >
                                <i className="fa fa-check mr-1"></i>
                                Verified
                              </span>
                            )}
                          </div>
                          <span className="text-danger">
                            {this.state.errorifscCode}
                          </span>
                        </div>

                        <div className="form-group col-md-6 col-12">
                          <label>Bank Address</label>
                          <input
                            id="bankAddress"
                            type="text"
                            className="form-control"
                            value={this.state.bankAddress}
                            onChange={this.onChange}
                            readOnly={true}
                          />
                          <span className="text-danger">
                            {this.state.errorbankAddress}
                          </span>
                        </div>
                        {/* {localStorage.getItem("source") !== 'mobile' &&  */}
                        <div className="form-group col-md-6 col-12">
                          <lable>
                            Attach you cancelled cheque/ Passbook image{" "}
                            <span className="text-danger"> *</span>
                          </lable>
                          <input
                            className="form-control"
                            onChange={this.onChange}
                            value={this.state.attachment}
                            id="attachment"
                            name="attachment"
                            type="file"
                          />{" "}
                          <span className="text-danger">
                            Note: <br />
                            Please select .jpeg and .png format only.
                            <br />
                            Maximum 5 MB Image allowed.
                          </span>
                          <br />
                          <span className="text-danger"></span>
                          <br />
                          <span className="text-danger">
                            {this.state.errorAttachment}
                          </span>
                        </div>
                        {/* } */}
                      </div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn-primary  btn "
                          onClick={this.backEnterAmountFun}
                        >
                          Back
                        </button>
                        <button
                          type="button"
                          className="btn_man btn ml-auto"
                          onClick={this.confirmDetailTabFun}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {/* upi transfer confirmation */}
                  {this.state.confirmDetailTab && this.state.upiTab == 1 && (
                    <>
                      <h5 className=" mb-3 text-center">
                        <b>Confirmation</b>
                      </h5>
                      <div className="row mt-4">
                        <div className="col-md-8 m-auto">
                          <div className="row mb-2">
                            <label className="col-md-4">
                              Withdrawal Initiated
                            </label>
                            <label className="col-md-6">
                              ₹ {this.state.amount}{" "}
                            </label>
                          </div>
                          <div className="row mb-2">
                            <label className="col-md-4">
                              Amount to be credited
                            </label>
                            <label className="col-md-6">
                              ₹{" "}
                              {Number(this.state.reciveWithdrawalFromWinning) +
                                Number(
                                  this.state.reciveWithdrawalFromDeposit
                                )}{" "}
                            </label>
                          </div>
                          <div className="row align-items-center">
                            <label className="col-md-4">
                              Your entered UPI ID
                            </label>
                            <label className="col-md-6">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="Enter  UPI ID"
                                value={this.state.upiId + this.state.bankupiId}
                                disabled={true}
                              />
                            </label>
                          </div>
                          <p className="text-danger">
                            Double check your entered UPI ID, as wrong UPI ID
                            can risk your funds to be lost completely
                          </p>
                        </div>
                      </div>
                      <div className="d-flex">
                        <button
                          type="button"
                          className="btn-primary  btn "
                          onClick={this.backtoEditUPI}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn_man btn ml-auto"
                          onClick={this.addrequest} disabled={this.state.disabledButton}

                        >
                          Submit
                        </button>
                      </div>
                    </>
                  )}
                  {/* bank detail confrimation  */}
                  {this.state.confirmDetailTab &&
                    this.state.bankTransferTab == 1 && (
                      <>
                        <h5 className=" mb-3 text-center">
                          <b>Confirmation</b>
                        </h5>
                        <div className="row mt-4">
                          <div className="col-md-8 m-auto">
                            <div className="row mb-2">
                              <label className="col-md-4">
                                Withdrawal Initiated
                              </label>
                              <label className="col-md-6">
                                ₹ {Number(this.state.amount).toFixed(2)}{" "}
                              </label>
                            </div>
                            <div className="row mb-2">
                              <label className="col-md-4">
                                You would receive
                              </label>
                              <label className="col-md-6">
                                ₹{" "}
                                {(
                                  Number(
                                    this.state.reciveWithdrawalFromWinning
                                  ) +
                                  Number(this.state.reciveWithdrawalFromDeposit)
                                ).toFixed(2)}{" "}
                              </label>
                            </div>
                            <div className="row align-items-center">
                              <label className="col-md-4">
                                Beneficiary Name
                              </label>
                              <label className="col-md-6">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter  Beneficiary Name"
                                  value={this.state.accountHolderNumber}
                                  disabled={true}
                                />
                              </label>
                            </div>
                            <div className="row align-items-center">
                              <label className="col-md-4">Bank Name</label>
                              <label className="col-md-6">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter  Bank Name"
                                  value={this.state.bankName}
                                  disabled={true}
                                />
                              </label>
                            </div>
                            <div className="row align-items-center">
                              <label className="col-md-4">
                                Bank Account No.
                              </label>
                              <label className="col-md-6">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter  Bank Account No."
                                  value={this.state.accountNumber}
                                  disabled={true}
                                />
                              </label>
                            </div>
                            <div className="row align-items-center">
                              <label className="col-md-4">IFSC Code</label>
                              <label className="col-md-6">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter  IFSC Code"
                                  value={this.state.ifscCode}
                                  disabled={true}
                                />
                              </label>
                            </div>
                            <p className="text-danger">
                              Double check your entered Bank Detail, as wrong
                              Bank Detail can risk your funds to be lost
                              completely
                            </p>
                          </div>
                        </div>
                        <div className="d-flex">
                          <button
                            type="button"
                            className="btn-primary  btn "
                            onClick={this.backtoEditBANK}
                          >
                            Edit
                          </button>
                          <button type="submit" className="btn_man btn ml-auto" disabled={this.state.disabledButton}> 
                            Submit
                          </button>
                        </div>
                      </>
                    )}
                </form>
              </div>
            </div>
          </div>
          {/* Withdrawal Modal Start */}

          <Modal
            className="fade modal add-fund-popup"
            show={this.state.stripePayment}
            onHide={this.closeModal}
          >
            <Modal.Header>
              <Modal.Title>Add Withdral Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <lable>
                Amount<span className="text-danger"> *</span>
              </lable>
              <input
                type="number"
                className="form-control"
                id="amount"
                onChange={this.onChange}
                value={this.state.amount}
              />
              <span className="text-danger">{this.state.errorAmount}</span>
              <div className="deposit-btn">
                <button
                  className="btn btn_man m-auto pl-5 pr-5"
                  onClick={this.adddrequest}
                >
                  Add Request
                </button>
              </div>
            </Modal.Body>
          </Modal>
          {/* Withdrawal Modal End */}
        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}

Withdral.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  withrawalRequest: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  contestdata: state.contestdata,
});

export default connect(mapStateToProps, { withrawalRequest })(
  withRouter(Withdral)
);